(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.RBUpsellRules = factory();
}(typeof window === 'undefined' ? {} : window, function () {
  'use strict';
  var MAX_DISCOUNTED_UNITS = 5;
  var MAX_VISIBLE_OFFERS = 5;
  var PARENTS = ['6650462929081', '6650466599097', '6650484064441', '6650487374009', '6650488783033', '8073762210032', '8308074152176', '16220818178426', '16221838475642', '16221840703866', '16221842669946'];
  var EXTRAS = ['6650512408761', '6681295683769', '6698952065209', '6728653406393', '6991350137017', '6991353381049', '6991355412665', '8103209926896'];
  var STRAWS = ['8402022465776', '14912508068218'];
  var BUNDLE_COMPONENTS = {
    '16220818178426': ['6650488783033', '6698952065209', '6681295683769', '6728653406393'],
    '16221838475642': ['6650466599097', '6698952065209', '6681295683769', '6728653406393'],
    '16221840703866': ['6650487374009', '6698952065209', '6681295683769', '6728653406393'],
    '16221842669946': ['6650462929081', '6698952065209', '6681295683769', '6728653406393']
  };
  var PREFERRED_ORDER = {
    '6650462929081': ['6698952065209', '6728653406393', '6991350137017', '6681295683769', '6650512408761'],
    '6650466599097': ['6698952065209', '6991355412665', '6728653406393', '6681295683769'],
    '6650487374009': ['6698952065209', '6728653406393', '6681295683769', '6991353381049'],
    '6650488783033': ['6991350137017', '6681295683769', '6650512408761', '6698952065209', '6728653406393']
  };

  function productId(line) { return String(line.product_id || line.productId || ''); }
  function quantity(line) { return Math.max(0, Number(line.quantity) || 0); }
  function lines(cart) { return Array.isArray(cart && cart.items) ? cart.items : []; }
  function containedIds(cart, parentComponents) {
    var ids = new Set((parentComponents || []).map(String));
    function visit(line) {
      if (quantity(line) < 1) return;
      var id = productId(line);
      if (id) ids.add(id);
      (BUNDLE_COMPONENTS[id] || []).forEach(function (component) { ids.add(component); });
      (line.item_components || []).forEach(visit);
    }
    lines(cart).forEach(visit);
    return ids;
  }
  function hasQualifier(cart) {
    return lines(cart).some(function (line) { return quantity(line) > 0 && PARENTS.indexOf(productId(line)) !== -1; });
  }
  function parentPresent(cart, parentId) {
    return containedIds(cart).has(String(parentId));
  }
  function validQuantity(value) {
    var amount = Number(value);
    return String(value).trim() !== '' && Number.isInteger(amount) && amount >= 1 && amount <= 10;
  }
  function canShowAutomatically(count, seenParents, parentId) {
    return Number.isInteger(count) && count >= 0 && count < 2 && seenParents.indexOf(String(parentId)) === -1;
  }
  function eligibleUnits(cart) {
    return lines(cart).reduce(function (sum, line) {
      return sum + (EXTRAS.indexOf(productId(line)) !== -1 && !line.parent_relationship ? quantity(line) : 0);
    }, 0);
  }
  function promotionActive(config, now) {
    if (config.currency !== 'GBP') return false;
    var endsAt = Date.parse(config.testUntil);
    var beforeEnd = Number.isFinite(endsAt) && (now === undefined ? Date.now() : now) < endsAt;
    if (config.priceMode === 'live') return !config.testUntil || beforeEnd;
    return config.priceMode === 'customer_test' && config.testCustomerEligible === true && beforeEnd;
  }
  function remainingUnits(cart) { return Math.max(0, MAX_DISCOUNTED_UNITS - eligibleUnits(cart)); }
  function offerAllowed(offer, parentId) {
    var id = String(parentId);
    if (STRAWS.indexOf(id) !== -1) return offer.kind === 'straw' && STRAWS.indexOf(String(offer.productId)) !== -1 && String(offer.productId) !== id;
    return PARENTS.indexOf(id) !== -1 && offer.kind === 'main' && EXTRAS.indexOf(String(offer.productId)) !== -1;
  }
  function filterOffers(offers, cart, parentId, components) {
    var contained = containedIds(cart, components);
    return offers.filter(function (offer) {
      return offerAllowed(offer, parentId) && !contained.has(String(offer.productId)) && offer.available !== false && Number.isSafeInteger(Number(offer.variantId)) && Number(offer.variantId) > 0 && Number.isFinite(offer.price) && offer.price > 0;
    });
  }
  function selectOffers(offers, cart, parentId, components) {
    var id = String(parentId);
    var order = PREFERRED_ORDER[id] || [];
    var seen = new Set();
    var limit = STRAWS.indexOf(id) !== -1 ? 1 : (BUNDLE_COMPONENTS[id] ? 2 : 3);
    return filterOffers(offers, cart, id, components).filter(function (offer) {
      var extraId = String(offer.productId);
      if (seen.has(extraId)) return false;
      seen.add(extraId);
      return true;
    }).map(function (offer, index) {
      var rank = order.indexOf(String(offer.productId));
      return { offer: offer, rank: rank < 0 ? order.length + index : rank };
    }).sort(function (a, b) { return a.rank - b.rank; })
      .slice(0, Math.min(MAX_VISIBLE_OFFERS, limit))
      .map(function (entry) { return entry.offer; });
  }
  function displayedPrice(offer, amount, cart, config, now) {
    var count = Math.max(1, Math.min(10, Math.trunc(Number(amount)) || 1));
    var original = offer.price * count;
    // Shopify chooses the winning non-combining offer. Before an addition, the
    // browser cannot know that allocation, so never present an estimated saving.
    return { original: original, total: original, saving: 0, quantity: count };
  }
  function variantQuantity(cart, variantId, offerCode) {
    return lines(cart).reduce(function (sum, line) {
      var same = String(line.variant_id || line.id) === String(variantId);
      var tagged = !offerCode || (line.properties && line.properties._rb_upsell_offer === offerCode);
      return sum + (same && tagged ? quantity(line) : 0);
    }, 0);
  }
  function reconcileAddition(before, after, expected, explicitlyRefused) {
    if (!Number.isInteger(after) || after < before) return { state: 'uncertain', retrySafe: false, added: 0 };
    var added = after - before;
    if (added >= expected) return { state: 'added', retrySafe: false, added: added };
    if (added > 0) return { state: 'partial', retrySafe: false, added: added };
    if (explicitlyRefused) return { state: 'refused', retrySafe: true, added: 0 };
    return { state: 'uncertain', retrySafe: false, added: 0 };
  }
  function nativeAddedPrice(cart, variantId, offerCode) {
    var matching = lines(cart).filter(function (line) {
      return String(line.variant_id || line.id) === String(variantId) && line.properties && line.properties._rb_upsell_offer === offerCode;
    });
    if (!matching.length || matching.some(function (line) { return !Number.isSafeInteger(line.original_line_price) || !Number.isSafeInteger(line.final_line_price); })) return null;
    var original = matching.reduce(function (sum, line) { return sum + line.original_line_price; }, 0);
    var total = matching.reduce(function (sum, line) { return sum + line.final_line_price; }, 0);
    return { original: original, total: total, saving: Math.max(0, original - total) };
  }
  return {
    MAX_DISCOUNTED_UNITS: MAX_DISCOUNTED_UNITS,
    parentIds: PARENTS,
    extraIds: EXTRAS,
    strawIds: STRAWS,
    containedIds: containedIds,
    hasQualifier: hasQualifier,
    parentPresent: parentPresent,
    validQuantity: validQuantity,
    canShowAutomatically: canShowAutomatically,
    eligibleUnits: eligibleUnits,
    promotionActive: promotionActive,
    remainingUnits: remainingUnits,
    offerAllowed: offerAllowed,
    filterOffers: filterOffers,
    selectOffers: selectOffers,
    displayedPrice: displayedPrice,
    variantQuantity: variantQuantity,
    reconcileAddition: reconcileAddition,
    nativeAddedPrice: nativeAddedPrice
  };
}));
